<template>
  <div :class="isH5 ? 'h5-course-info' : ''" class="course-info">
    <div class="left">
      <img :src="courseInfo.cover_url + '?imageView2/0/w/640'" alt="" />
    </div>
    <div class="right">
      <div class="course-name">{{ courseInfo.course_name }}</div>
      <div class="course-tag">
        <div class="tag" v-for="(item, index) in courseTag" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="group-price">
        <div class="price">
          <span>￥</span>{{ (activeInfo.group_price / 100).toFixed(2) }}
        </div>
        <div class="origin-price">
          ￥{{ (courseInfo.goods?.price / 100).toFixed(2) }}
        </div>
        <div class="num">{{ activeInfo.group_num }}人起拼</div>
      </div>
      <div class="unit">
        {{ courseInfo.unit_count }}课时
        <span
          v-if="
            courseInfo.goods && courseInfo.goods.show_enrollment_count === 1
          "
          ><span class="separate"></span>
          {{ million(courseInfo.enrollment_count) }}人已学</span
        >
      </div>
      <div class="unit">
        课程有效期至：
        <span v-if="courseInfo.validity_type === 2"
          >随到随学{{ courseInfo.enrollment_days }}天</span
        >
        <span v-if="courseInfo.validity_type === 3">永久有效</span>
        <span v-if="courseInfo.validity_type === 1"
          >{{
            moment(courseInfo.course_end_time * 1000).format("YYYY年MM月DD日")
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { isH5 } from "@saas/components/src";
import { million } from "@saas/components/src/utils/utils";
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
    activeInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      moment,
      isH5: isH5(),
      million,
    };
  },
  computed: {
    // 课程标签
    courseTag() {
      return (this.courseInfo.goods?.goods_tag || "").split(",");
    },
  },
};
</script>

<style lang="scss" scoped>
.course-info {
  width: 800px;
  min-height: 226px;
  border-radius: 24px;
  background-color: #fff;
  margin-top: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  padding: 24px 35px 24px 24px;
  .left {
    width: 320px;
    height: 180px;
    overflow: hidden;
    border-radius: 16px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .right {
    margin-left: 14px;
    flex: 1;
    .course-name {
      width: 100%;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: $saas-text-color;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 显示两行 */
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .course-tag {
      margin-top: 4px;
      min-height: 21px;
      overflow: hidden;
      .tag {
        float: left;
        padding: 0 4px;
        height: 21px;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00cb9b;
        background: #ebfff6;
        border-radius: 6px;
        margin-right: 4px;
        margin-top: 4px;
      }
    }
    .group-price {
      margin-top: 4px;
      height: 33px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      .price {
        line-height: 1;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #f03349;
        text-align: left;
        font-style: normal;
        span {
          font-size: 12px;
        }
      }
      .num {
        margin-left: 10px;
        box-sizing: border-box;
        height: 24px;
        line-height: 22px;
        border-radius: 8px;
        border: 1px solid rgba(240, 51, 73, 0.3);
        padding: 0 3px;
        font-size: 14px;
        color: #f03349;
      }
    }
    .origin-price {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #747573;
      line-height: 1;
      margin-bottom: 1px;
      text-align: left;
      font-style: normal;
      text-decoration-line: line-through;
      margin-left: 5px;
    }
    .unit {
      margin-top: 10px;
      height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #747573;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      .separate {
        display: inline-block;
        width: 1px;
        height: 11px;
        background: #efefef;
        margin: 0 8px;
      }
    }
  }
}
.h5-course-info {
  width: 9.3867rem;
  height: auto;
  margin: 0.32rem auto 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 0;
  .left {
    width: 100%;
    height: 5.2267rem;
    border-radius: 0.32rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .right {
    margin-left: 0;
    margin-top: 0.2133rem;
    flex: auto;
    padding: 0 0.1467rem;
    .course-name {
      width: 100%;
      font-size: 0.4267rem;
      line-height: 0.6rem;
    }
    .course-tag {
      margin-top: 0.1067rem;
      min-height: 0.56rem;
      .tag {
        padding: 0 0.1067rem;
        height: 0.56rem;
        line-height: 0.56rem;
        font-size: 0.32rem;
        border-radius: 0.16rem;
        margin-top: 0.1067rem;
        margin-right: 0.1067rem;
      }
    }
    .group-price {
      margin-top: 0.1867rem;
      height: 0.6rem;
      .price {
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.4267rem;
        span {
          font-size: 0.2667rem;
        }
      }
      .num {
        margin-left: 0.16rem;
        height: 0.52rem;
        line-height: 0.52rem;
        border-radius: 0.16rem;
        padding: 0 0.1467rem;
        font-size: 0.2933rem;
      }
    }
    .origin-price {
      margin-top: 0.1333rem;
      height: 0.2933rem;
      font-size: 0.32rem;
      line-height: 0.2933rem;
    }
    .unit {
      margin-top: 0.2133rem;
      height: 0.4rem;
      font-size: 0.2933rem;
      line-height: 0.4rem;
    }
  }
}
</style>
